import { useEffect } from 'react'

/**
 * Triggers the browser's beforeunload prompt while `dirty` is true so users
 * don't lose changes by refreshing or closing the tab. In-app navigation is
 * not blocked here because the app uses the legacy BrowserRouter which doesn't
 * support `useBlocker` — the visible ChangesBar serves as the in-app cue.
 */
export function useUnsavedGuard(dirty: boolean) {
  useEffect(() => {
    if (!dirty) return
    const handler = (e: BeforeUnloadEvent) => {
      e.preventDefault()
      // Modern browsers ignore the message string but still show a generic
      // prompt when preventDefault is called.
      e.returnValue = ''
    }
    window.addEventListener('beforeunload', handler)
    return () => window.removeEventListener('beforeunload', handler)
  }, [dirty])
}
